export default __webpack_public_path__ + "static/media/support-iot-studio.6b7df4cc.yaml";